import { useEffect } from 'react';

function IconShield() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3.75l7.5 3v5.25c0 4.875-3.137 8.925-7.5 10.25C7.637 20.925 4.5 16.875 4.5 12V6.75l7.5-3z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 12.75l1.5 1.5 3.75-4.5" />
    </svg>
  );
}

function IconDatabase() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 6.75c0-1.657 3.358-3 7.5-3s7.5 1.343 7.5 3-3.358 3-7.5 3-7.5-1.343-7.5-3z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 6.75v5.25c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3V6.75M4.5 12v5.25c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3V12" />
    </svg>
  );
}

function IconLock() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V7.5a4.5 4.5 0 00-9 0v3M6.75 10.5h10.5A1.5 1.5 0 0118.75 12v7.5A1.5 1.5 0 0117.25 21H6.75a1.5 1.5 0 01-1.5-1.5V12a1.5 1.5 0 011.5-1.5z" />
    </svg>
  );
}

function IconPlug() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 7.5V3.75M15 7.5V3.75M7.5 7.5h9v3.75a4.5 4.5 0 01-9 0V7.5zM12 15.75v4.5" />
    </svg>
  );
}

function IconUserCheck() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.25a7.5 7.5 0 0115 0M16.5 13.5l1.5 1.5 3-3" />
    </svg>
  );
}

function IconDocument() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-3a9 9 0 00-9-9H6.75A1.5 1.5 0 005.25 3.75v16.5a1.5 1.5 0 001.5 1.5h10.5a1.5 1.5 0 001.5-1.5v-6z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 2.25v6A1.5 1.5 0 0012 9.75h6M8.25 15h7.5M8.25 18h4.5" />
    </svg>
  );
}

function Card({ children, className = '' }) {
  return (
    <div className={`rounded-xl border p-5 border-gray-200 bg-white dark:border-brand-50/10 dark:bg-brand-800/40 ${className}`}>
      {children}
    </div>
  );
}

function ControlCard({ icon, title, text }) {
  return (
    <Card>
      <div className="flex items-center gap-2.5 mb-2 text-gray-700 dark:text-brand-200">
        {icon}
        <h3 className="font-semibold text-[15px] m-0">{title}</h3>
      </div>
      <p className="text-[14px] leading-relaxed text-gray-500 dark:text-brand-500 m-0">{text}</p>
    </Card>
  );
}

function FlowStep({ label, description, isLast }) {
  return (
    <div className="flex-1 min-w-[130px]">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-2.5 h-2.5 rounded-full bg-gray-800 dark:bg-brand-100" />
        {!isLast && <div className="h-px flex-1 bg-gray-200 dark:bg-brand-50/10" />}
      </div>
      <p className="text-[13px] font-semibold text-gray-800 dark:text-brand-200 mb-1">{label}</p>
      <p className="text-[12px] leading-relaxed text-gray-500 dark:text-brand-500 m-0">{description}</p>
    </div>
  );
}

function Table({ rows }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-brand-50/10 mb-8">
      <table className="w-full text-[14px] text-left border-collapse">
        <tbody className="divide-y divide-gray-100 dark:divide-brand-50/5">
          {rows.map(([label, value]) => (
            <tr key={label}>
              <th className="w-[34%] py-3 px-4 align-top text-[11px] font-bold uppercase tracking-widest text-gray-400 dark:text-brand-600 bg-gray-50/70 dark:bg-brand-900/30">
                {label}
              </th>
              <td className="py-3 px-4 align-top text-gray-600 dark:text-brand-400">{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function DataPrivacySecurity({ onHeadingsExtracted }) {
  useEffect(() => {
    if (onHeadingsExtracted) {
      onHeadingsExtracted([
        { text: 'Privacy at a glance', level: 2, id: 'privacy-at-a-glance' },
        { text: 'How data moves through PABS', level: 2, id: 'how-data-moves-through-pabs' },
        { text: 'What PABS stores', level: 2, id: 'what-pabs-stores' },
        { text: 'AI and model training', level: 2, id: 'ai-and-model-training' },
        { text: 'Access and connectors', level: 2, id: 'access-and-connectors' },
        { text: 'Subprocessors', level: 2, id: 'subprocessors' },
        { text: 'Security reviews', level: 2, id: 'security-reviews' },
        { text: 'Enterprise compliance', level: 2, id: 'enterprise-compliance' },
      ]);
    }
  }, [onHeadingsExtracted]);

  return (
    <article className="min-w-0 max-w-[760px]">
      <div className="mb-10 rounded-2xl border border-gray-200 bg-gray-50 dark:border-brand-50/10 dark:bg-brand-900/40 p-6 overflow-hidden relative">
        <div className="absolute top-0 right-0 w-40 h-40 border border-gray-200 dark:border-brand-50/10 rounded-full translate-x-16 -translate-y-16" />
        <div className="relative">
          <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-gray-500 dark:border-brand-50/10 dark:bg-brand-800 dark:text-brand-400 mb-5">
            <IconShield />
            Privacy and security
          </div>
          <h1 className="text-3xl font-bold tracking-tighter mt-0 mb-3 leading-tight text-gray-900 dark:text-brand-50">
            Data, privacy, and security
          </h1>
          <p className="text-[16px] leading-relaxed max-w-[620px] text-gray-600 dark:text-brand-400 mb-0">
            PABS is built for sensitive product strategy work: briefs, customer problems, research notes, market assumptions, product decisions, and delivery context. Your workspace is private by default.
          </p>
        </div>
      </div>

      <h2 id="privacy-at-a-glance" className="text-xl font-semibold tracking-tight mt-10 mb-5 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        Privacy at a glance
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
        <ControlCard icon={<IconShield />} title="No data selling" text="PABS does not sell customer data. Your strategy content is used to provide the product." />
        <ControlCard icon={<IconDatabase />} title="Private workspace" text="Plans are tied to authenticated users, and private routes check plan ownership." />
        <ControlCard icon={<IconLock />} title="Protected credentials" text="Passwords are hashed. Connector tokens are encrypted before storage using AES-256-GCM." />
        <ControlCard icon={<IconUserCheck />} title="Human approval" text="AI can propose changes, but the live strategy only changes after a human approves or edits them." />
      </div>

      <h2 id="how-data-moves-through-pabs" className="text-xl font-semibold tracking-tight mt-10 mb-5 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        How data moves through PABS
      </h2>
      <Card className="mb-10">
        <div className="flex flex-col sm:flex-row gap-4">
          <FlowStep label="Brief" description="You add product context, goals, constraints, and assumptions." />
          <FlowStep label="Strategy" description="PABS turns that context into a living strategy model." />
          <FlowStep label="AI work" description="Relevant context is sent to AI providers only when needed for a requested action." />
          <FlowStep label="Review" description="Recommendations and strategy changes stay human-gated." isLast />
        </div>
      </Card>

      <h2 id="what-pabs-stores" className="text-xl font-semibold tracking-tight mt-10 mb-4 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        What PABS stores
      </h2>
      <p className="text-[15px] leading-relaxed mb-5 text-gray-600 dark:text-brand-400">
        PABS stores the strategy model and the signals needed to explain it, not a broad copy of every connected workspace.
      </p>
      <Table rows={[
        ['Account', 'Name, email, plan type, billing status, and account settings.'],
        ['Strategy workspace', 'Briefs, strategies, assumptions, decisions, hypotheses, action plans, analysis, and generated documents.'],
        ['Activity context', 'Conversations, agent activity, learnings, Pulse results, recommendations, and share-link settings.'],
        ['Connectors', 'Connector status, selected bindings, compact signals, provenance, call metadata, and encrypted credentials where needed.'],
      ]} />

      <h2 id="ai-and-model-training" className="text-xl font-semibold tracking-tight mt-10 mb-4 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        AI and model training
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
        <Card>
          <p className="text-[11px] font-bold uppercase tracking-widest mb-2.5 text-gray-400 dark:text-brand-600">What PABS does</p>
          <p className="text-[14px] leading-relaxed text-gray-600 dark:text-brand-400 m-0">
            Sends relevant plan context to AI providers when you ask PABS to generate, review, answer, summarize, or run a strategic job.
          </p>
        </Card>
        <Card>
          <p className="text-[11px] font-bold uppercase tracking-widest mb-2.5 text-gray-400 dark:text-brand-600">What PABS does not do</p>
          <p className="text-[14px] leading-relaxed text-gray-600 dark:text-brand-400 m-0">
            PABS does not use customer content to train PABS-owned AI models and does not intentionally send unrelated plans into AI requests.
          </p>
        </Card>
      </div>
      <p className="text-[15px] leading-relaxed mb-10 text-gray-600 dark:text-brand-400">
        API provider training and retention are governed by the provider's business/API data terms and any enterprise data controls in place. Enterprise customers should ask for the AI data handling terms they require, including zero data retention where available.
      </p>

      <h2 id="access-and-connectors" className="text-xl font-semibold tracking-tight mt-10 mb-5 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        Access and connectors
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
        <ControlCard icon={<IconUserCheck />} title="Shared links are explicit" text="Shared plan links are read-only, can be scoped to visible sections, and can be revoked by the plan owner." />
        <ControlCard icon={<IconPlug />} title="Connectors are opt-in" text="PABS only reads from external tools after the user authorizes access with that provider." />
        <ControlCard icon={<IconShield />} title="MCP is plan-scoped" text="External AI builder access is scoped to a specific plan token. A token for one plan cannot read another plan." />
        <ControlCard icon={<IconLock />} title="Disconnect means cleanup" text="Disconnecting a connector removes its credentials and connector-derived records from PABS." />
      </div>

      <h2 id="subprocessors" className="text-xl font-semibold tracking-tight mt-10 mb-4 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        Subprocessors
      </h2>
      <p className="text-[15px] leading-relaxed mb-5 text-gray-600 dark:text-brand-400">
        PABS uses subprocessors to provide the product. The exact vendors may change as the platform evolves, but the categories are:
      </p>
      <Table rows={[
        ['AI providers', 'Generate strategy, analysis, documents, Pulse output, and agent responses.'],
        ['Hosting and database', 'Run the application and store customer workspace data.'],
        ['Email delivery', 'Send account, product, and notification emails.'],
        ['Billing', 'Manage subscriptions, invoices, and payments.'],
        ['Analytics and monitoring', 'Understand product usage, reliability, errors, and system health.'],
        ['Connector providers', 'Access external tools the user explicitly authorizes.'],
      ]} />

      <h2 id="security-reviews" className="text-xl font-semibold tracking-tight mt-10 mb-4 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        Security reviews
      </h2>
      <p className="text-[15px] leading-relaxed mb-5 text-gray-600 dark:text-brand-400">
        PABS can provide answers for common privacy and security reviews. A typical review may cover:
      </p>
      <Table rows={[
        ['Encryption', 'Data is protected in transit using TLS. Connector credentials are encrypted before storage.'],
        ['Authentication', 'Users authenticate with account credentials. Passwords are hashed and are not stored in plain text.'],
        ['Access control', 'Private plan routes check ownership. Shared links are read-only and revocable.'],
        ['AI training', 'PABS does not use customer content to train PABS-owned AI models.'],
        ['Data deletion', 'Account deletion removes associated PABS data, subject to backups and legally required records.'],
        ['Retention', 'Plans are retained while the account is active unless deletion is requested or a separate agreement applies.'],
      ]} />

      <h2 id="enterprise-compliance" className="text-xl font-semibold tracking-tight mt-10 mb-4 leading-snug scroll-mt-20 text-gray-900 dark:text-brand-50">
        Enterprise compliance
      </h2>
      <Card className="mb-8 border-gray-300 dark:border-brand-50/20">
        <div className="flex items-start gap-3">
          <div className="text-gray-700 dark:text-brand-200 mt-0.5"><IconDocument /></div>
          <div>
            <p className="text-[15px] font-semibold text-gray-800 dark:text-brand-200 mb-1">Privacy controls and enterprise certification are different things.</p>
            <p className="text-[14px] leading-relaxed text-gray-600 dark:text-brand-400 m-0">
              Do not treat PABS as SOC 2 certified unless a current SOC 2 report is available. PABS can support a security review and discuss requirements such as DPA terms, a current subprocessor list, AI data handling, retention requirements, SSO, audit logs, and other controls required before wider rollout.
            </p>
          </div>
        </div>
      </Card>

      <div className="rounded-xl border border-gray-200 bg-gray-50/70 dark:border-brand-50/10 dark:bg-brand-800/40 p-5">
        <p className="text-[15px] font-semibold text-gray-800 dark:text-brand-200 mb-1">Privacy, security, or enterprise review questions?</p>
        <p className="text-[14px] leading-relaxed text-gray-600 dark:text-brand-400 m-0">
          Contact <a className="underline underline-offset-2 text-gray-700 dark:text-brand-300 hover:text-gray-900 dark:hover:text-brand-50 transition-colors" href="mailto:support@pabs.co.nz">support@pabs.co.nz</a> and include the security requirements your organization needs PABS to meet.
        </p>
      </div>
    </article>
  );
}
